import * as React from 'react';
import { memo } from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { FilterUrlParams } from 'modules/search/types';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Radio } from '@daedalus/atlas/Radio';
import { SegmentedControl } from '@daedalus/atlas/SegmentedControl';
import { reviewSentimentMessages } from '@daedalus/core/src/hotel/reviewSentiments';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wfp1dqo",
  propsAsIs: false
});
interface ReviewScoreFilterProps {
  value: string;
  variant?: 'segmented' | 'radio';
  onChange: (filters: FilterUrlParams) => void;
}
const ReviewScoreFilterComponent: React.FC<ReviewScoreFilterProps> = ({
  value,
  variant = 'segmented',
  onChange
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    isMobile
  } = useDeviceLayout();
  const handleChange = (reviewScore: string) => {
    const value = reviewScore === 'any' ? undefined : reviewScore;
    onChange({
      reviewScore: value
    });
  };
  const isActiveFilter = (score: string) => {
    if (!value && score === 'any') return true;
    return score === value;
  };
  if (variant === 'radio') return <>
        <Radio hasTouchArea fullWidth checked={isActiveFilter('any')} name={`reviewScore-any`} label={formatMessage({
      id: 'any',
      defaultMessage: 'Any'
    })} onChange={() => handleChange('any')} labelSize={isMobile ? 'bodyM' : 'bodyS'} />
        <Radio hasTouchArea fullWidth checked={isActiveFilter('9')} name={`reviewScore-9`} label={`${formatMessage(reviewSentimentMessages['superb'])} 9+`} onChange={() => handleChange('9')} labelSize={isMobile ? 'bodyM' : 'bodyS'} />
        <Radio hasTouchArea fullWidth checked={isActiveFilter('8')} name={`reviewScore-8`} label={`${formatMessage(reviewSentimentMessages['veryGood'])} 8+`} onChange={() => handleChange('8')} labelSize={isMobile ? 'bodyM' : 'bodyS'} />
        <Radio hasTouchArea fullWidth checked={isActiveFilter('7')} name={`reviewScore-7`} label={`${formatMessage(reviewSentimentMessages['good'])} 7+`} onChange={() => handleChange('7')} labelSize={isMobile ? 'bodyM' : 'bodyS'} />
      </>;
  return <Wrapper>
      <SegmentedControl name="reviewScore" value={value ?? 'any'} onChange={handleChange}>
        <SegmentedControl.Item value="any">
          {formatMessage({
          id: 'any',
          defaultMessage: 'Any'
        })}
        </SegmentedControl.Item>
        <SegmentedControl.Item value="7">7.0+</SegmentedControl.Item>
        <SegmentedControl.Item value="8">8.0+</SegmentedControl.Item>
        <SegmentedControl.Item value="9">9.0+</SegmentedControl.Item>
      </SegmentedControl>
    </Wrapper>;
};
export const ReviewScoreFilter = memo(ReviewScoreFilterComponent);

require("./ReviewScoreFilter.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ReviewScoreFilter.tsx");